import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-massachusetts-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./massachusetts-state-form.component.html",
  styleUrl: "./massachusetts-state-form.component.scss",
})
export class MassachusettsStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
